import { useMemo, useContext, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from './components/Layout';
import 'react-toastify/dist/ReactToastify.css';
import Feedback from 'components/common/Feedback';
import privateRoutes from './routes/PrivateRoutes';
import AppLoader from 'components/common/AppLoader';
import WalletConnector from 'components/WalletConnect';
import UseRefreshHook from 'components/Hooks/UseRefreshHook';
import ThemeContext from 'components/context/ThemeContext';
import Helmet from 'react-helmet';

const App = () => {
    const { theme } = useContext(ThemeContext);
    //Use Selectors
    const { apiStatusTrade } = useSelector(
        (state) => state.Trade
    );

    // get chains, fetch pools info
    UseRefreshHook();

    //Leave us feedback redirection
    const handleRedirection = () => {
        window.open(process.env.REACT_APP_FEEDBACK_URL);
    };

    const isGlobalLoaderActive = useMemo(
        () => apiStatusTrade?.length > 0 ||
            process.env.REACT_APP_UPGRADE_MESSAGE === 'true',
        [apiStatusTrade?.length],
    );

    const lastErrorMessage = useMemo(
        () => apiStatusTrade?.length > 0 ?
            apiStatusTrade[apiStatusTrade.length - 1].payload :
            null,
        [apiStatusTrade],
    );

    return (
        <div id="main-container" data-theme={theme}>
            <Helmet
                defaultTitle="VirtuSwap"
                titleTemplate={'%s | VirtuSwap'}
            >
                <meta
                    name="description"
                    content="VirtuSwap - the most efficient DEX. VirtuSwap is for 99 Percent Assets what Curve is for Stablecoins. Based on advanced financial engineering and AI governance."
                />
            </Helmet>
            {isGlobalLoaderActive ? (
                <AppLoader
                    message={
                        (lastErrorMessage === 'Network Error' || lastErrorMessage === 'Unable to access the network') ?
                            'Unable to connect, please check your network connection.' :
                        'We are upgrading our front end, please try again soon.'
                    }
                />
            ) : (
                <Layout>
                    <WalletConnector />
                    <Routes>
                        {privateRoutes.map(({ element: Element, path }) => (
                            <Route key={path} path={path} element={
                                <Suspense fallback={<AppLoader />}>
                                    <Element />
                                </Suspense>
                            } />
                        ))}
                    </Routes>
                    <Feedback handleRedirection={handleRedirection} />
                </Layout>
            )}
        </div>
    );
};

export default App;
